module.exports = __webpack_public_path__ + "img/merica-bourbon-monitor.98d36125.png";